module.exports = __webpack_public_path__ + "static/img/4734_phase_function_Paper_PointsHejduk_Prediction.b8560a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4734_phase_function_Paper_PointsHejduk_Prediction.png
// module id = W7xh
// module chunks = 0